import { DecisionOption, DecisionQuestion, DecisionQuestionType } from "@/types/prompt-blueprint";

export const QUESTION_TYPE_LABELS: Record<DecisionQuestionType, string> = {
  binary: "Yes / No",
  choice: "Choice",
  score: "Score",
};

export const QUESTION_TYPE_HINTS: Record<DecisionQuestionType, string> = {
  binary: "Returns the probability that the answer is yes.",
  choice: "Picks one option and returns a probability for each.",
  score: "Rates on ordered levels, lowest first. Returns the expected level.",
};

const DEFAULT_OPTIONS: Record<DecisionQuestionType, DecisionOption[]> = {
  binary: [],
  choice: [{ value: "option_a" }, { value: "option_b" }],
  score: [{ value: "low" }, { value: "medium" }, { value: "high" }],
};

export const MAX_OPTIONS: Record<DecisionQuestionType, number> = {
  binary: 0,
  choice: 255,
  score: 10,
};

export const createQuestion = (existing: DecisionQuestion[]): DecisionQuestion => {
  const names = new Set(existing.map(question => question.name));
  let index = existing.length + 1;
  while (names.has(`question_${index}`)) {
    index += 1;
  }
  return { name: `question_${index}`, type: "binary", instructions: "" };
};

export const changeQuestionType = (
  question: DecisionQuestion,
  type: DecisionQuestionType,
): DecisionQuestion => {
  if (type === "binary") {
    return { name: question.name, type, instructions: question.instructions };
  }
  const keepOptions = question.type !== "binary" && (question.options?.length ?? 0) >= 2;
  const options = keepOptions ? question.options : DEFAULT_OPTIONS[type];
  return { ...question, type, options: options?.slice(0, MAX_OPTIONS[type]) };
};
